import Layout from '@/components/Layout';
import EmailNotifications from './Email';

const Notifications = () => {
  return (
    <Layout title="Notifications & Alerts" subtitle="Control shipment alerts and automate workflows for status updates.">
      <EmailNotifications />
    </Layout>
  );
};

export default Notifications;
